import { View } from 'foundations-components/components/View';
import HighlightHeaderAndContainerSkeleton from './HighlightHeaderAndContainerSkeleton';
import CreateActivityButtonsSkeleton from 'crm-activity-creator-widgets/buttons/CreateActivityButtonsSkeleton';
import { useMemo } from 'react';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecordHighlightFullSkeleton = ({
  objectType
}) => {
  const objectTypeId = useMemo(() => {
    return normalizeTypeId(objectType);
  }, [objectType]);
  return /*#__PURE__*/_jsxs(View, {
    padding: "400",
    paddingBlockEnd: "600",
    children: [/*#__PURE__*/_jsx(HighlightHeaderAndContainerSkeleton, {
      objectTypeId: objectTypeId
    }), /*#__PURE__*/_jsx(CreateActivityButtonsSkeleton, {})]
  });
};
export default RecordHighlightFullSkeleton;